import { NavigateOptions, useSearchParams } from 'react-router-dom';

export function usePagination(): [
  number,
  (newPage: number, options?: NavigateOptions) => void
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = (parseInt(searchParams.get('page') || '1') || 1) - 1;

  const setPage = (newPage: number, options?: NavigateOptions) => {
    // note: doesn't support repeated keys
    const params = Object.fromEntries(searchParams.entries());
    if (newPage === 0) {
      delete params.page;
    } else {
      params.page = (newPage + 1).toString();
    }
    setSearchParams(params, options);
  };
  return [page, setPage];
}
